import { ClsParametro } from 'src/app/core/models/cls-parametros';
import {EnumParaPpto} from '../../core/models/enum/enum-parametros';

export class ClsObjParametrosPorPpto {
  constructor() {
  }

  public getParametrosDefaultsPpto(): ClsParametro[] {
    return [
      // {
      //   IdParametro: BigInt('0'),
      //   Llave: BigInt('0'),
      //   Parametro: EnumParaPpto.MONEDA1,
      //   Valor: 'M.N.',
      //   Descripcion: 'Clave de la moneda 1'
      // },
      // {
      //   IdParametro: BigInt('0'),
      //   Llave: BigInt('0'),
      //   Parametro: EnumParaPpto.DESCRIPCIONMONEDA1,
      //   Valor: 'PESOS',
      //   Descripcion: 'Descripcion de la moneda 1'
      // },
      // {
      //   IdParametro: BigInt('0'),
      //   Llave: BigInt('0'),
      //   Parametro: EnumParaPpto.MONEDA2,
      //   Valor: 'USD',
      //   Descripcion: 'Clave de la moneda 2'
      // },
      // {
      //   IdParametro: BigInt('0'),
      //   Llave: BigInt('0'),
      //   Parametro: EnumParaPpto.DESCRIPCIONMONEDA2,
      //   Valor: 'DOLARES',
      //   Descripcion: 'Descripcion de la moneda 2'
      // },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.AREACLIENTE,
        Valor: 'AREA',
        Descripcion: 'Area del cliente que convoca'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.DEPARTAMENTOCLIENTE,
        Valor: 'DEPARTAMENTO',
        Descripcion: 'Departamento del cliente que licita.'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.OTROSSOBRECOSTO,
        Valor: 'TIIE',
        Descripcion: 'Indicador de referencia de sobrecosto'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.OTROSPARTIDAS,
        Valor: '.',
        Descripcion: 'Caracter separador de partidas'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.OTROREPORTE,
        Valor: '1',
        Descripcion: 'Número máximo de filas para combinar el campo Descripción:'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALDECCU,
        Valor: '2',
        Descripcion: 'Número decimal para redondeo CU e Importe'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALDECCANTPPTO,
        Valor: '4',
        Descripcion: 'Número decimal para redondeo cantidad ppto'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALDECEXPINS,
        Valor: '8',
        Descripcion: 'Número decimal para redondeo exp. ins.'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALTIPOEXPINS,
        Valor: '0',
        Descripcion: 'Tipo de explosión de insumos'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALMOSTRARERRPOT,
        Valor: '0',
        Descripcion: 'Mostrar errores potenciales'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALTASAINTERES,
        Valor: '12',
        Descripcion: 'Tasa de interes para los costos horarios'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALORDENARMATXTIPOINS,
        Valor: '0',
        Descripcion: 'Ordenar matrices x tipo insumo'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALASIGNARFECHAINS,
        Valor: '0',
        Descripcion: 'Asignar fecha a insumos'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALFECHAINS,
        Valor: '',
        Descripcion: 'Fecha asignado a insumos'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALPARAMONEDAS,
        Valor: '0',
        Descripcion: 'Parámetros monedas'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALFACTORM1,
        Valor: '1',
        Descripcion: 'Factor para Moneda1'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALFACTORM2,
        Valor: '1',
        Descripcion: 'Factor para Moneda2'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALEXPINSXCONCEPTO,
        Valor: '0',
        Descripcion: 'Calcular explosión de insumos por concepto'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALEXPLOTARINSCH,
        Valor: '0',
        Descripcion: 'Explotar insumos de costo horario'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CALNOEXPLOTARINSINT,
        Valor: '0',
        Descripcion: 'No explotar insumos integrados'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.PPTOCOSTOTOTAL,
        Valor: '0',
        Descripcion: 'Costo total del ppto'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.PPTOPRECIOTOTAL,
        Valor: '0',
        Descripcion: 'Precio total del ppto'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.PPTOPORCSOBRECOSTO,
        Valor: '000.0000',
        Descripcion: 'Porcentaje de sobrecosto para el ppto'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.URLCONTENIDO,
        Valor: '',
        Descripcion: 'Contenido detallado del presupuesto'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.PPTOMAESTROVINCULADO,
        Valor: '0',
        Descripcion: 'Ultimo presupuesto maestro vinculado al presupuesto activo'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.LICFECHALICITACION,
        Valor: '',
        Descripcion: 'Fecha de licitación.'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.LICNUMLICITACION,
        Valor: '',
        Descripcion: 'Número de licitación.'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.LICLUGARCELEBRACION,
        Valor: '',
        Descripcion: 'Lugar de celebración.'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.LICNUMCONVOCATORIA,
        Valor: '',
        Descripcion: 'Número de convocatoria.'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.LICFECHAPUBLICACION,
        Valor: '',
        Descripcion: 'Fecha de publicación de la convocatoria.'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.LICFECHAINICIO,
        Valor: '',
        Descripcion: 'Fecha de inicio de la obra.'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.LICFECHAFINAL,
        Valor: '',
        Descripcion: 'Fecha de terminación de la obra.'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBNOMBRELIBROPI1,
        Valor: '',
        Descripcion: 'Nombre libro de pie de indirecto moneda 1'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBINDIRECTOTOTAL1,
        Valor: '0',
        Descripcion: 'Indirecto total moneda 1'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBFINANCIAMIENTO1,
        Valor: '0',
        Descripcion: 'Financiamiento moneda 1'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBINDIRECTOCAMPO1,
        Valor: '0',
        Descripcion: 'Indirecto de campo moneda 1'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBUTILIDAD1,
        Valor: '0',
        Descripcion: 'Utilidad moneda 1'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBINDIRECTOOFICINA1,
        Valor: '0',
        Descripcion: 'Indirecto oficina moneda 1'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBCARGOSADICIONALES1,
        Valor: '0',
        Descripcion: 'Cargos adicionales moneda 1'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBNOMBRELIBROPI2,
        Valor: '',
        Descripcion: 'Nombre libro de pie de indirecto moneda 2'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBINDIRECTOTOTAL2,
        Valor: '0',
        Descripcion: 'Indirecto total moneda 2'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBFINANCIAMIENTO2,
        Valor: '0',
        Descripcion: 'Financiamiento moneda 2'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBINDIRECTOCAMPO2,
        Valor: '0',
        Descripcion: 'Indirecto de campo moneda 2'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBUTILIDAD2,
        Valor: '0',
        Descripcion: 'Utilidad moneda 2'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBINDIRECTOOFICINA2,
        Valor: '0',
        Descripcion: 'Indirecto oficina moneda 2'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBCARGOSADICIONALES2,
        Valor: '0',
        Descripcion: 'Cargos adicionales moneda 2'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.SOBPORCENTAJESOBRECOSTO2,
        Valor: '0',
        Descripcion: 'Porcentaje de sobrecosto moneda 2'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHDEPRECIACIONE,
        Valor: '100',
        Descripcion: 'Porcentaje depreciacion espera'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHDEPRECIACIONR,
        Valor: '15',
        Descripcion: 'Porcentaje depreciacion reserva'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHINVERSIONE,
        Valor: '100',
        Descripcion: 'Porcentaje inversion espera'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHINVERSIONR,
        Valor: '100',
        Descripcion: 'Porcentaje inversion reserva'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHSEGUROSE,
        Valor: '100',
        Descripcion: 'Porcentaje seguros espera'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHSEGUROSR,
        Valor: '100',
        Descripcion: 'Porcentaje seguros reserva'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHMANTENIMIENTOE,
        Valor: '0',
        Descripcion: 'Porcentaje mantenimiento espera'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHMANTENIMIENTOR,
        Valor: '15',
        Descripcion: 'Porcentaje mantenimiento reserva'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHCOMBUSTIBLEE,
        Valor: '5',
        Descripcion: 'Porcentaje combustible espera'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHCOMBUSTIBLER,
        Valor: '0',
        Descripcion: 'Porcentaje combustible reserva'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHLUBRICANTESE,
        Valor: '5',
        Descripcion: 'Porcentaje lubricantes espera'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHLUBRICANTESR,
        Valor: '0',
        Descripcion: 'Porcentaje lubricantes reserva'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHLLANTASE,
        Valor: '15',
        Descripcion: 'Porcentaje de llantas espera'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHLLANTASR,
        Valor: '0',
        Descripcion: 'Porcentaje de llantas reserva'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHPIEZAESPE,
        Valor: '0',
        Descripcion: 'Porcentaje de piezas especiales espera'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHPIEZAESPR,
        Valor: '0',
        Descripcion: 'Porcentaje de piezas especiales reserva'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHOPERACIONE,
        Valor: '100',
        Descripcion: 'Porcentaje operancion espera'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHOPERACIONR,
        Valor: '100',
        Descripcion: 'Porcentaje operancion reserva'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHOTRASFUENTESENERGIAE,
        Valor: '5',
        Descripcion: 'Porcentaje otras fuentes de energía espera'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHOTRASFUENTESENERGIAR,
        Valor: '0',
        Descripcion: 'Porcentaje otras fuentes de energía reserva'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHINDREFERENCIA,
        Valor: 'TIIE',
        Descripcion: 'Indicador de referencia'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHINDESPECIFICOSEGUROS,
        Valor: 'TIIE',
        Descripcion: 'Indicador especifico de seguros'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHFACTORLUBRICANTEP0,
        Valor: '0.0030',
        Descripcion: 'Factor de lubricante para potencia 0'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHFACTORLUBRICANTEPMAYOR0,
        Valor: '0.0033',
        Descripcion: 'Factor de lubricante para potencia mayor a 0'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHFACTORCOMBUTIBLEGASOLINA,
        Valor: '0.2271',
        Descripcion: 'Factor de combustible gasolina'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHFACTORCOMBUTIBLEDIESEL,
        Valor: '0.1514',
        Descripcion: 'Factor de combustible diesel'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHFACTORCOMBUTIBLEOTROS,
        Valor: '0',
        Descripcion: 'Factor de combustible otros'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHNOMBRELIBROCH,
        Valor: 'EstandarCostoHorario.xlsx',
        Descripcion: 'Libro Costo Horario default'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaPpto.CHTIENELIBROCH,
        Valor: '0',
        Descripcion: 'Validar si tiene libro de CH'
      }
    ];
  }

  public getParametrosCalculo(): ClsParametro[] {
    return [
      {
        Parametro: EnumParaPpto.CALTIPOEXPINS,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CALMOSTRARERRPOT,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CALTASAINTERES,
        Valor: '12'
      },
      {
        Parametro: EnumParaPpto.CALASIGNARFECHAINS,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CALFECHAINS,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.CALPARAMONEDAS,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CALFACTORM1,
        Valor: '1'
      },
      {
        Parametro: EnumParaPpto.CALFACTORM2,
        Valor: '1'
      },
      {
        Parametro: EnumParaPpto.CALEXPINSXCONCEPTO,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CALPROGSUM,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CALEXPLOTARINSCH,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CALNOEXPLOTARINSINT,
        Valor: '0'
      },
      {
          Parametro: EnumParaPpto.CALDECCU,
          Valor: '2'
      },
      {
        Parametro: EnumParaPpto.CALDECCANTPPTO,
        Valor: '4'
      },
      {
        Parametro: EnumParaPpto.CALDECEXPINS,
        Valor: '8'
      },
      {
        Parametro: EnumParaPpto.PPTOCOSTOTOTAL,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.PPTOPRECIOTOTAL,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.RESPALDARPORCORREO,
        Valor: '1'
      },
      {
        Parametro: EnumParaPpto.IDPROGRAMA,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.SCIMPORTEMOGRAVABLE1,
        Valor: '0'
      }
    ];
  }

  public getParametrosEncabezado(): ClsParametro[] {
    return [
      {
        Parametro: EnumParaPpto.LICFECHAINICIO,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.LICFECHAFINAL,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.AREACLIENTE,
        Valor: 'AREA'
      },
      {
        Parametro: EnumParaPpto.DEPARTAMENTOCLIENTE,
        Valor: 'DEPARTAMENTO'
      },
      {
        Parametro: EnumParaPpto.LICFECHALICITACION,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.LICNUMLICITACION,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.LICLUGARCELEBRACION,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.PPTOPRECIOTOTAL,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.MONEDA1,
        Valor: 'M.N.'
      },
      {
        Parametro: EnumParaPpto.DESCRIPCIONMONEDA1,
        Valor: 'PESOS'
      },
      {
        Parametro: EnumParaPpto.MONEDA2,
        Valor: 'USD'
      },
      {
        Parametro: EnumParaPpto.DESCRIPCIONMONEDA2,
        Valor: 'DOLARES'
      },
      {
        Parametro: EnumParaPpto.LICNUMCONVOCATORIA,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.LICFECHAPUBLICACION,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.CALDECCU,
        Valor: '2'
      }
    ];
  }

  public getParametrosDetallePpto(): ClsParametro[] {
    return [
      {
        Parametro: EnumParaPpto.AREACLIENTE,
        Valor: 'AREA'
      },
      {
        Parametro: EnumParaPpto.DEPARTAMENTOCLIENTE,
        Valor: 'DEPARTAMENTO'
      },
      {
        Parametro: EnumParaPpto.MONEDA1,
        Valor: 'M.N.'
      },
      {
        Parametro: EnumParaPpto.DESCRIPCIONMONEDA1,
        Valor: 'PESOS'
      },
      {
        Parametro: EnumParaPpto.MONEDA2,
        Valor: 'USD'
      },
      {
        Parametro: EnumParaPpto.DESCRIPCIONMONEDA2,
        Valor: 'DOLARES'
      },
      {
        Parametro: EnumParaPpto.OTROSPARTIDAS,
        Valor: '.',
      },
      {
        Parametro: EnumParaPpto.URLCONTENIDO,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.LICFECHALICITACION,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.LICNUMLICITACION,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.LICLUGARCELEBRACION,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.LICNUMCONVOCATORIA,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.LICFECHAPUBLICACION,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.LICFECHAINICIO,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.LICFECHAFINAL,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.CHDEPRECIACIONE,
        Valor: '100'
      },
      {
        Parametro: EnumParaPpto.CHDEPRECIACIONR,
        Valor: '15'
      },
      {
        Parametro: EnumParaPpto.CHINVERSIONE,
        Valor: '100'
      },
      {
        Parametro: EnumParaPpto.CHINVERSIONR,
        Valor: '100'
      },
      {
        Parametro: EnumParaPpto.CHSEGUROSE,
        Valor: '100'
      },
      {
        Parametro: EnumParaPpto.CHSEGUROSR,
        Valor: '100'
      },
      {
        Parametro: EnumParaPpto.CHMANTENIMIENTOE,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CHMANTENIMIENTOR,
        Valor: '15'
      },
      {
        Parametro: EnumParaPpto.CHCOMBUSTIBLEE,
        Valor: '5'
      },
      {
        Parametro: EnumParaPpto.CHCOMBUSTIBLER,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CHLUBRICANTESE,
        Valor: '5'
      },
      {
        Parametro: EnumParaPpto.CHLUBRICANTESR,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CHLLANTASE,
        Valor: '15'
      },
      {
        Parametro: EnumParaPpto.CHLLANTASR,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CHPIEZAESPE,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CHPIEZAESPR,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CHOPERACIONE,
        Valor: '100'
      },
      {
        Parametro: EnumParaPpto.CHOPERACIONR,
        Valor: '100'
      },
      {
        Parametro: EnumParaPpto.CHOTRASFUENTESENERGIAE,
        Valor: '5'
      },
      {
        Parametro: EnumParaPpto.CHOTRASFUENTESENERGIAR,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CHFACTORLUBRICANTEP0,
        Valor: '0.0030'
      },
      {
        Parametro: EnumParaPpto.CHFACTORLUBRICANTEPMAYOR0,
        Valor: '0.0033'
      },
      {
        Parametro: EnumParaPpto.CHFACTORCOMBUTIBLEGASOLINA,
        Valor: '0.2271'
      },
      {
        Parametro: EnumParaPpto.CHFACTORCOMBUTIBLEDIESEL,
        Valor: '0.1514'
      },
      {
        Parametro: EnumParaPpto.CHFACTORCOMBUTIBLEOTROS,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CHINDREFERENCIA,
        Valor: 'TIIE'
      },
      {
        Parametro: EnumParaPpto.CHINDESPECIFICOSEGUROS,
        Valor: 'TIIE'
      },
      {
        Parametro: EnumParaPpto.CALDECCU,
        Valor: '2'
      },
      {
        Parametro: EnumParaPpto.CALDECCANTPPTO,
        Valor: '4'
      },
      {
        Parametro: EnumParaPpto.CALDECEXPINS,
        Valor: '8'
      },
      {
        Parametro: EnumParaPpto.CHNOMBRELIBROCH,
        Valor: 'EstandarCostoHorario.xlsx'
      },
      {
        Parametro: EnumParaPpto.FNOMBRELIBRO,
        Valor: ''
      },
      // {
      //   Parametro: EnumParaPpto.FNOMBRELIBRO2,
      //   Valor: ''
      // },
      {
        Parametro: EnumParaPpto.SOBNOMBRELIBROPI1,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.SOBNOMBRELIBROSC1,
        Valor: ''
      },
      // {
      //   Parametro: EnumParaPpto.SOBNOMBRELIBROPI2,
      //   Valor: ''
      // },
      // {
      //   Parametro: EnumParaPpto.SOBNOMBRELIBROSC2,
      //   Valor: ''
      // },
      {
        Parametro: EnumParaPpto.PPTOCOSTOTOTAL,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.PPTOPRECIOTOTAL,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CALPARAMONEDAS,
        Valor: '0'
      }
    ];
  }

  public getParametrosAbrirPpto(): ClsParametro[] {
    return [
      {
        Parametro: EnumParaPpto.CALDECCU,
        Valor: '2'
      },
      {
        Parametro: EnumParaPpto.CALDECCANTPPTO,
        Valor: '4'
      },
      {
        Parametro: EnumParaPpto.CALDECEXPINS,
        Valor: '8'
      },
      {
        Parametro: EnumParaPpto.PPTOCOSTOTOTAL,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.PPTOPRECIOTOTAL,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CALPARAMONEDAS,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.PPTOMAESTROVINCULADO,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.CHNOMBRELIBROCH,
        Valor: 'EstandarCostoHorario.xlsx'
      }
    ];
  }

  public getParametrosSobrecosto(): ClsParametro[] {
    return [
      {
        Parametro: EnumParaPpto.SOBNOMBRELIBROPI1,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.SOBINDIRECTOTOTAL1,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SOBFINANCIAMIENTO1,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SOBINDIRECTOCAMPO1,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SOBUTILIDAD1,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SOBINDIRECTOOFICINA1,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SOBCARGOSADICIONALES1,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.PPTOPORCSOBRECOSTO,
        Valor: '000.0000'
      },
      {
        Parametro: EnumParaPpto.SOBNOMBRELIBROSC1,
        Valor: ''
      },
      {
        Parametro: EnumParaPpto.SCFACTORSFP1,
        Valor: '0.005'
      },
      {
        Parametro: EnumParaPpto.SCINDICADORREFERENCIA1,
        Valor: 'CETES'
      },
      {
        Parametro: EnumParaPpto.SCPORCENTAJEUTILIDADPROPUESTA1,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SCTASAINITERES1,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SCPUNTOSBANCO1,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SCPORCENTAJEANTICIPO11,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SCIMPORTEMOGRAVABLE1,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SCPERIODOENTREGAANTICIPO21,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SCPROGRAMA1,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SCTIPOANTICIPO1,
        Valor: '1'
      },
      {
        Parametro: EnumParaPpto.SCPORCENTAJEANTICIPO21,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.SCIMPORTEEJERCICIO11,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.PPTOCOSTOTOTAL,
        Valor: '0'
      },
      {
        Parametro: EnumParaPpto.PPTOPRECIOTOTAL,
        Valor: '0'
      }
      //
      // {
      //   Parametro: EnumParaPpto.SOBNOMBRELIBROSC2,
      //   Valor: ''
      // },
      // {
      //   Parametro: EnumParaPpto.SOBNOMBRELIBROPI2,
      //   Valor: ''
      // },
      // {
      //   Parametro: EnumParaPpto.SOBINDIRECTOTOTAL2,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SOBFINANCIAMIENTO2,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SOBINDIRECTOCAMPO2,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SOBUTILIDAD2,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SOBINDIRECTOOFICINA2,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SOBCARGOSADICIONALES2,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SOBPORCENTAJESOBRECOSTO2,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SCFACTORSFP2,
      //   Valor: '0.005'
      // },
      // {
      //   Parametro: EnumParaPpto.SCINDICADORREFERENCIA2,
      //   Valor: 'CETES'
      // },
      // {
      //   Parametro: EnumParaPpto.SCPORCENTAJEUTILIDADPROPUESTA2,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SCTASAINITERES2,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SCPUNTOSBANCO2,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SCPORCENTAJEANTICIPO12,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SCIMPORTEMOGRAVABLE2,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SCPERIODOENTREGAANTICIPO22,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SCPROGRAMA2,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SCTIPOANTICIPO2,
      //   Valor: '1'
      // },
      // {
      //   Parametro: EnumParaPpto.SCPORCENTAJEANTICIPO22,
      //   Valor: '0'
      // },
      // {
      //   Parametro: EnumParaPpto.SCIMPORTEEJERCICIO12,
      //   Valor: '0'
      // }
    ];
  }

  public getParametrosLibros(): ClsParametro[] {
    // {
    //   Parametro: EnumParaPpto.SOBNOMBRELIBROPI2
    // },
    return [
      {
        Parametro: EnumParaPpto.SOBNOMBRELIBROPI1
      },
      {
        Parametro: EnumParaPpto.CHNOMBRELIBROCH
      }
    ]
  }

  public getParametrosCalSobrecosto(): ClsParametro[] {
    return [
      {
        Parametro: EnumParaPpto.PPTOPORCSOBRECOSTO
      },
      {
        Parametro: EnumParaPpto.SOBPORCENTAJESOBRECOSTO2
      }
    ];
  }

  public getParametrosCalCH(): ClsParametro[] {
    // {
    //   Parametro: EnumParaPpto.CHNOMBRELIBROCH
    // },
    return [
      {
        Parametro: EnumParaPpto.CHDEPRECIACIONE
      },
      {
        Parametro: EnumParaPpto.CHDEPRECIACIONR
      },
      {
        Parametro: EnumParaPpto.CHINVERSIONE
      },
      {
        Parametro: EnumParaPpto.CHINVERSIONR
      },
      {
        Parametro: EnumParaPpto.CHSEGUROSE
      },
      {
        Parametro: EnumParaPpto.CHSEGUROSR
      },
      {
        Parametro: EnumParaPpto.CHMANTENIMIENTOE
      },
      {
        Parametro: EnumParaPpto.CHMANTENIMIENTOR
      },
      {
        Parametro: EnumParaPpto.CHCOMBUSTIBLEE
      },
      {
        Parametro: EnumParaPpto.CHCOMBUSTIBLER
      },
      {
        Parametro: EnumParaPpto.CHLUBRICANTESE
      },
      {
        Parametro: EnumParaPpto.CHLUBRICANTESR
      },
      {
        Parametro: EnumParaPpto.CHLLANTASE
      },
      {
        Parametro: EnumParaPpto.CHLLANTASR
      },
      {
        Parametro: EnumParaPpto.CHPIEZAESPE
      },
      {
        Parametro: EnumParaPpto.CHPIEZAESPR
      },
      {
        Parametro: EnumParaPpto.CHOPERACIONE
      },
      {
        Parametro: EnumParaPpto.CHOPERACIONR
      },
      {
        Parametro: EnumParaPpto.CHOTRASFUENTESENERGIAE
      },
      {
        Parametro: EnumParaPpto.CHOTRASFUENTESENERGIAR
      },
      {
        Parametro: EnumParaPpto.CHINDREFERENCIA
      },
      {
        Parametro: EnumParaPpto.CHINDESPECIFICOSEGUROS
      }
    ];
  }

  public getParametrosCalLibroPIM1(): ClsParametro[] {
    return [
      {
        Parametro: EnumParaPpto.SOBINDIRECTOTOTAL1
      },
      {
        Parametro: EnumParaPpto.SOBINDIRECTOOFICINA1
      },
      {
        Parametro: EnumParaPpto.SOBINDIRECTOCAMPO1
      },
      {
        Parametro: EnumParaPpto.SOBFINANCIAMIENTO1
      },
      {
        Parametro: EnumParaPpto.SOBUTILIDAD1
      },
      {
        Parametro: EnumParaPpto.SOBCARGOSADICIONALES1
      }
    ];
  }

  public getParametrosCalLibroPIM2(): ClsParametro[] {
    return [
      {
        Parametro: EnumParaPpto.SOBINDIRECTOTOTAL2
      },
      {
        Parametro: EnumParaPpto.SOBINDIRECTOOFICINA2
      },
      {
        Parametro: EnumParaPpto.SOBINDIRECTOCAMPO2
      },
      {
        Parametro: EnumParaPpto.SOBFINANCIAMIENTO2
      },
      {
        Parametro: EnumParaPpto.SOBUTILIDAD2
      },
      {
        Parametro: EnumParaPpto.SOBCARGOSADICIONALES2
      }
    ];
  }

  public getParametrosFasar(): ClsParametro[] {
    return [
      { Parametro: EnumParaPpto.FANIOAPLICACION },
      { Parametro: EnumParaPpto.FSALARIOMINIMO },
      { Parametro: EnumParaPpto.FUMA },
      { Parametro: EnumParaPpto.FNOMINA },
      { Parametro: EnumParaPpto.FPAGOSTERCEROS },
      { Parametro: EnumParaPpto.FSAR },
      { Parametro: EnumParaPpto.FINFONAVIT },
      { Parametro: EnumParaPpto.FCONSIDERARPRESTACIONES },
      { Parametro: EnumParaPpto.FRIESGOTRABAJO },
      { Parametro: EnumParaPpto.FNOMBRELIBRO }
    ]

    // { Parametro: EnumParaPpto.FANIOAPLICACION2 },
    // { Parametro: EnumParaPpto.FSALARIOMINIMO2 },
    // { Parametro: EnumParaPpto.FUMA2 },
    // { Parametro: EnumParaPpto.FNOMINA2 },
    // { Parametro: EnumParaPpto.FPAGOSTERCEROS2 },
    // { Parametro: EnumParaPpto.FSAR2 },
    // { Parametro: EnumParaPpto.FINFONAVIT2 },
    // { Parametro: EnumParaPpto.FCONSIDERARPRESTACIONES2 },
    // { Parametro: EnumParaPpto.FRIESGOTRABAJO2 },
    // { Parametro: EnumParaPpto.FNOMBRELIBRO2 },
  }
}
